import { render } from "./SideContainer.vue?vue&type=template&id=62d8d65e&ts=true"
import script from "./SideContainer.vue?vue&type=script&lang=ts"
export * from "./SideContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__